import React from 'react';
import styled, { css } from 'styled-components';
import { ThemeTypes } from '../../../theme/theme';
import { useTopmenuProvider } from './TopmenuProvider';

interface TypeTopmenuButton {
  mobileHidden?: Boolean;
  borderLeft?: Boolean;
  theme: ThemeTypes;
  className: string;
  transparent: boolean;
  isLightMode?: boolean;
}

const StyledTopmenuButton =
  styled.button <
  TypeTopmenuButton >
  `
  display: flex;
  align-items: center;
  appearance: none;
  border: none;
  color: ${(props) => props.isLightMode ? props.theme.colors.offWhite : props.theme.colors.title};
  background-color: transparent;
  border-radius: 40px;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.75px;
  width: auto;
  padding: 0 16px;

  &:active,
  &:hover {
    color: ${(props) => props.theme.colors.title};
    background-color: ${(props) =>
      props.isLightMode ? props.theme.colors.white : props.theme.colors.white};
    svg{
      path {
        stroke: ${(props) => props.theme.colors.title};
      }
      rect{
        fill: ${(props) => props.theme.colors.title};
      }
    }
  }

  ${(props: TypeTopmenuButton) => {
    if (props.borderLeft) {
      return css`
        border-left: 1px solid ${props.theme.colors.inputBackground};
      `;
    }

    return '';
  }}

  ${(props) => props.theme.mediaQuerie.maxWidth.md} {
    display: ${(props) => (props.mobileHidden ? 'none' : 'block')};
  }

  ${(props) => props.theme.mediaQuerie.minWidth.md} {
    width: auto;
    padding: 0 25px;
    height: 48px;
    border-radius: 24px;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  p {
    margin-bottom: 0px;
    ${(props) => props.theme.mediaQuerie.minWidth.md} {
      display: block;
      margin: 0;
    }
  }

  svg {
    path {
      stroke: ${(props) => props.isLightMode ? props.theme.colors.offWhite : props.theme.colors.title};
    }
    rect {
      fill: ${(props) => props.isLightMode ? props.theme.colors.offWhite : props.theme.colors.title};
    }
    ${(props) => props.theme.mediaQuerie.minWidth.md} {
      margin-right: 8px;
    }
  }
`;

const TopmenuButton = (props: any) => {
  const { className, borderLeft, mobileHidden, isLightMode, ...rest } = props;
  const { transparent } = useTopmenuProvider();

  return (
    <StyledTopmenuButton
      {...rest}
      transparent={transparent}
      isLightMode={isLightMode}
      borderLeft={borderLeft}
      mobileHidden={mobileHidden}
      className={`button-topmenu ${className}`}
    />
  );
};

TopmenuButton.defaultProps = {
  mobileHidden: false,
  borderLeft: false,
};

export default TopmenuButton;
